import { LanguageContext } from '../../../../context/LanguageContext';
import classes from './CategoryCards.module.css';
import { useState } from 'react';

const CategoryCards = (props) => {
  const { data, categories, className, image, maxWidth = null} = props;
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltipPos({ top: rect.bottom + 6, left: rect.left });
    setHovered(true);
  };

  const filteredData = categories?.filter((item) => (data?.categories ?? data)?.includes(item?._id ?? item))

  return (
    <LanguageContext.Consumer>
      {(ctx) => {
        const names = filteredData?.map((item) => item?.name?.[ctx.language]).filter(Boolean);
        const categoryNames = names?.join(', ');

        return (
          <div className={`${classes.data_container} ${!maxWidth && className} d-flex align-items-center`} style={{ ...(maxWidth && { maxWidth }) }}>
            {image && filteredData?.map((item) => (
              <img
                key={item._id ?? item}
                src={`${process.env.REACT_APP_DEV_URI}${item.image?.imageURL}`}
                alt=''
                className={classes.category_image}
              />
            ))}

            <span
              className={classes.category_text}
              style={{ position: 'relative', cursor: 'pointer' }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={() => setHovered(false)}
            >
              {categoryNames}
            </span>

            {hovered && names?.length > 1 && (
              <div className={classes.tooltip} style={{ position: 'fixed', top: tooltipPos.top, left: tooltipPos.left }}>
                {names.map((name, i) => (
                  <div key={i} className={classes.tooltip_item}>{`■ ${name}`}</div>
                ))}
              </div>
            )}
          </div>
        );
      }}
    </LanguageContext.Consumer>
  );
};

export default CategoryCards;
